console.log($("body"));
const sectionSlideshow = () => {
  $(".section-slideshow-swiper:not(.swiper-container-initialized)").each(
    function() {
      const options = $(this).data("js-swiper-options");
      console.log(options);
      new Swiper(this, options);
    }
  );
};
sectionSlideshow();
document.addEventListener("DOMContentLoaded", sectionSlideshow);
//document.addEventListener("shopify:section:load", sectionSlideshow);
